import { H4 } from "@/components/reusables/typography";

const LoadingScreen: React.FC = () => {
  return (
    <>
      <main className='flex flex-col items-center justify-center w-screen h-screen'>
        {/* <div className='w-8 h-8 p-2 border-2 rounded-full border-t-rose-500 animate-spin'></div> */}
        <span className='loader'></span>
        <H4 className='mt-4'>Checking Security </H4>
        <p>Please wait while we ensure your connection is secure.</p>
      </main>
    </>
  );
};

export default LoadingScreen;
